// serviceWorker.ready can resolve the /app/ attention worker. Legacy push must
// use its own root registration, including after a reversible feature rollback.
export async function getRootPushRegistration() {
  const root = await navigator.serviceWorker.register('/sw.js', { scope: '/' });
  if (root.active) return root;
  await new Promise((resolve, reject) => {
    const worker = root.installing || root.waiting;
    if (!worker) { reject(new Error('Root push worker unavailable')); return; }
    const done = () => { clearTimeout(timeout); worker.removeEventListener('statechange', changed); };
    const changed = () => {
      if (worker.state === 'activated') { done(); resolve(); }
      else if (worker.state === 'redundant') { done(); reject(new Error('Root push worker activation failed')); }
    };
    const timeout = setTimeout(() => { done(); reject(new Error('Root push worker activation timeout')); }, 5000);
    worker.addEventListener('statechange', changed);
    changed();
  });
  return root;
}
